import React from "react";
import { Typography, Grid, Box, Container, Button, Link } from "@mui/material";
import parse from "html-react-parser";

type CardImageTextReactTypes = {
    DomPurify: Function;
    translatedData: {
      imageUrl: string;
      imageAltText: string;
      imageWidth: string;
      imageHeight: string;
      header: string;
      paragraph: string;
      linkText: string;
      linkUrl: string;
      linkAriaLabel: string;
    };
  };
  export default function CardImageTextReact(props: CardImageTextReactTypes) {
    console.log(props.translatedData);
    return (
      <Container
        sx={{
          display: "flex",
          flexDirection: { lg: "row", xs: "column" },
          borderRadius: "30px",
          padding: { xs: "0rem", lg: "0px" },
          backgroundColor: "#F8F8F8",
          maxWidth: { sm: "700px", lg: "1280px" },
        }}
      >
        {/* Image */}
        <Box
          component="img"
          src={props.translatedData.imageUrl}
          alt={props.translatedData.imageAltText}
          sx={{
            maxWidth: {
              lg: props.translatedData.imageWidth ? props.translatedData.imageWidth : "50%",
              sm: props.translatedData.imageWidth ? props.translatedData.imageWidth : "100%",
            },
  
            maxHeight: {
              lg: props.translatedData.imageHeight ? props.translatedData.imageHeight : "auto",
              sm: props.translatedData.imageHeight ? props.translatedData.imageHeight : "auto",
            },
  
            objectFit: "contain",
            borderRadius: { lg: "30px 0px 0px 30px", xs: "30px 30px 0px 0px" },
          }}
        />
  
        {/* Header and Texts */}
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems={{ lg: "flex-start", xs: "center" }}
          spacing={{ lg: "3", sm: "0" }}
          sx={{
            marginTop: { lg: "0rem", sm: "-11rem", xs: "-5rem" },
            zIndex: "2",
            backgroundColor: "#F8F8F8",
            borderRadius: { lg: "0px 30px 30px 0px", xs: "0px 0px 30px 30px" },
            padding: { lg: "0rem 4rem", sm: "0rem 4rem", xs: "0rem 22px" },
          }}
        >
          <Grid item mt={5}>
            <Typography
              variant="h2"
              sx={{
                textAlign: { lg: "left", xs: "center" },
                fontSize: { lg: "36px", xs: "28px" },
                marginBottom:'22px',
              }}
  
            >
              {props.translatedData.header}
            </Typography>
          </Grid>
  
          <Grid item>
            <Typography
              sx={{
                color: "#262626",
                fontSize: { lg: "18px", xs: "16px" },
                textAlign: { lg: "left", xs: "center" },
                lineHeight:'1.5',
              }}
            >
              {parse(props.translatedData.paragraph)}
            </Typography>
          </Grid>
  
          <Grid item mb={5}>
            <Button
              variant="outlined"
              component={Link}
              size="large"
              aria-label={props.translatedData.linkAriaLabel}
              href={props.translatedData.linkUrl}
              className="secondary-btn-white"
              sx={{
                maxWidth: { lg: "100%", xs: "100%" },
                marginTop:{ lg: "40px", xs: "16px"},              
                padding: { lg: "0.8rem 1.8rem 0.8rem 1.8rem", sm: "0.5rem 2.2rem 0.5rem 2.2rem" },
                textAlign: "center",
              }}
            >
              {props.translatedData.linkText}
            </Button>
          </Grid>
        </Grid>
      </Container>
    );
    
            }